import createStore from './store';

export * from './const';
export * from './types';
export default createStore;


// WEBPACK FOOTER //
// ./src/store/deferred/index.ts